export default "assets/images/9d3a01c866095b8b3e8e63f9cf11dd51.png";